export enum UIActionButtonContext {
    MESSAGE_ACTION = 'messageAction',
    ROOM_ACTION = 'roomAction',
    MESSAGE_BOX_ACTION = 'messageBoxAction',
    USER_DROPDOWN_ACTION = 'userDropdownAction',
    ROOM_SIDEBAR_ACTION = 'roomSideBarAction',
}
